import { css } from 'styled-components';

export const AiFillGradientBackground = css`
  background: linear-gradient(90.71deg, #ebf0ff 0.61%, #e8fff7 119.53%);
`;
